module.exports = __webpack_public_path__ + "static/media/google_24.751f7f85.svg";